export default __webpack_public_path__ + "static/media/img (1).6c48ba8a.jpg";